module.exports = __webpack_public_path__ + "img/118ne.187368de.svg";